// extracted by mini-css-extract-plugin
module.exports = {"paid-order-list":"paid-order-list-eb790c0d9cd71f16c0759d5fb0401e56","order-table":"order-table-996dce06acd707167aec9e267ec09093"};